import { Link } from 'react-router-dom';
import type { AgencyAggregate } from '@/lib/assessments';

type Props = {
  agencies: AgencyAggregate[];
  /** Set when the strip shows something other than what the page's stamp covers. */
  caption?: string;
};

export function AgencyStrip({ agencies, caption }: Props) {
  if (agencies.length === 0) return null;
  return (
    <section data-testid="agency-strip">
      {caption ? (
        <p className="text-label uppercase tracking-[0.08em] text-text-secondary">{caption}</p>
      ) : null}
      <h2 className="font-display text-h3 font-semibold">Coverage by agency</h2>
      <ul className="mt-5 flex gap-4 overflow-x-auto pb-2">
        {agencies.map((a) => {
          const pct = a.total > 0 ? Math.round((a.meeting / a.total) * 100) : 0;
          return (
            <li
              key={a.code}
              className="min-w-[200px] flex-shrink-0 rounded-lg border border-border bg-surface transition hover:border-accent"
            >
              <Link
                to={`/report/agency/${encodeURIComponent(a.code)}`}
                className="block p-5 focus:outline-none focus-visible:ring-2 focus-visible:ring-accent/40"
              >
                <p className="font-display text-h3 font-semibold text-text-primary">
                  {a.code}
                </p>
                <p className="mt-1 text-body-sm text-text-secondary">{a.name}</p>
                <div className="mt-3 flex items-baseline gap-2">
                  <span className="font-display text-h3 font-bold text-accent">
                    {pct}%
                  </span>
                  <span className="text-body-sm text-text-secondary">
                    {a.notMeeting > 0 ? `${a.notMeeting} deficient` : 'All clear'}
                  </span>
                </div>
              </Link>
            </li>
          );
        })}
      </ul>
    </section>
  );
}
